import { useCallback, useEffect, useState } from "react";

import { useAppState } from "../../state";

import FeatureFlagList from "./FeatureFlagList";

import {
  Button,
  Card,
  Row,
  Col,
  Spinner,
} from "react-bootstrap";

import FeatureFlag from "./FeatureFlag";

async function DummySave(featureFlags: FeatureFlag[]): Promise<Response> {
  const seed = Math.floor(Math.random() * (2 - 1 + 1)) + 1;

  switch (seed) {
    case 1:
      return new Response(JSON.stringify({
        successful: true,
        ok: true,
        message: "Feature flags saved successfully",
        flags: featureFlags
      }), { status: 200, statusText: "OK" });
    case 2:
      return new Response(JSON.stringify({
        successful: false,
        ok: false,
        message: "Error saving feature flags",
        flags: featureFlags
      }), { status: 400, statusText: "Bad Request" });
    default:
      return new Response(JSON.stringify({ status: 500, successful: false, ok: false, message: "Unknown error", flags: [] }), { status: 500, statusText: "Internal Server Error" });
  }
}

async function GetDummyData(id: number, count: number = 1): Promise<FeatureFlag[]> {
  function createDummyFlags(countStart: number): FeatureFlag[] {
    return [
      {
        id: id + countStart,
        name: "test1",
        description: "Short description",
        startDate: new Date("2026-07-14T00:00:00.000-04:00"),
        endDate: null,
        enabled: true
      },
      {
        id: id + countStart + 1,
        name: "test2",
        description: "This is a very long description. It goes on for a while. There are details, instructions, and other information. It needs to be truncated or wrapped or both else the table will break",
        startDate: new Date("2026-07-14T00:00:00.000-04:00"),
        endDate: new Date("2026-07-18T20:00:00.000-04:00"),
        enabled: false
      },
      {
        id: id + countStart + 2,
        name: "test3",
        description: "Medium description, clarifying",
        startDate: new Date(),
        endDate: new Date(),
        enabled: true
      }
    ];
  }

  let dummyFlags: FeatureFlag[] = [];
  for (let i = 1; i < count; i++) {
    dummyFlags = [...dummyFlags, ...createDummyFlags((i - 1) * 3)];
  }

  return dummyFlags;
}

export default function ToggleFeatureFlagsPage() {
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [saveSucceed, setSaveSucceed] = useState(false);

  const [errorMessage, setErrorMessage] = useState<(string | null)>("");
  const [cardCSSClass, setCardCSSClasses] = useState("");

  const [featureFlags, setFeatureFlags] = useState<FeatureFlag[]>([]);

  const { onAppStateRefresh } = useAppState();

  useEffect(() => {
    GetDummyData(5, 15)
      .then(data => {
        setFeatureFlags(data);
      });
  }, []);

  const onToggleEnabled = useCallback((id: number, enabled: boolean) => {
    setFeatureFlags((current) =>
      current.map((flag) => (flag.id === id ? { ...flag, enabled } : flag))
    );
  }, []);

  async function onSaveClick(): Promise<boolean> {
    try {
      setSaveSucceed(false);

      var seed = Math.floor(Math.random() * (100 - 1 + 1)) + 1;
      if (seed > 50) {
        setErrorMessage("error");
        setCardCSSClasses("form-group has-error");
      }
      else {
        setErrorMessage(null);
        setCardCSSClasses("");
      }
      setIsSaveLoading(true);

      const response = await DummySave(featureFlags);
      let responseBody = await response.json();
      switch (response.status) {
        case 400:
          Object.keys(responseBody).map((key) => {
            const fieldName = key.charAt(0).toLowerCase() + key.substring(1);
            return fieldName;
          });
          break;
        case 200:
          if (responseBody.successful === true) {
            onAppStateRefresh();
          }
          setSaveSucceed(true);
          break;
        default:
          break;
      }
      setIsSaveLoading(false);
      return response.ok;
    }
    catch (e) {
      console.log(e);
    }
    setIsSaveLoading(false);
    return false;
  }

  let errorMessageContent;
  if (errorMessage && errorMessage.length > 0) {
    errorMessageContent = (
      <Row>
        <Col className="d-flex justify-content-center">
          <label className="error">{errorMessage}</label>
        </Col>
      </Row>
    );
  }

  let succeedMessageContent;
  if (saveSucceed) {
    succeedMessageContent = (
      <Row>
        <Col className="d-flex justify-content-center">
          <label className="success">Feature flags saved successfully</label>
        </Col>
      </Row>
    );
  }

  let saveButtonContent = (
    <>
      <i className="fa fa-save"></i>
      {" "}Save
    </>
  );

  if (isSaveLoading) {
    saveButtonContent = (
      <>
        <Spinner animation="border" size="sm" />
        <span> Saving... </span>
      </>
    );
  }

  const pageTitleContent = (
    <Card.Header>
      <p>Enable one or more feature flag(s) by turning on and off the switch near each flag.<br />
        Note: Changing the feature flags will require you to log out from the application, close the browser window and all tabs, then open a new browser window for the new setting to get in effect</p>
    </Card.Header>
  );

  return (
    <Card className={`table-with-switches bg-white border-0 flagCard ${cardCSSClass}`} id="tableCard">
      {pageTitleContent}
      <Card.Body>
        <FeatureFlagList featureFlags={featureFlags} onToggleEnabled={onToggleEnabled} />
        <Row>
          <Col className="d-flex finalColumn">
            <Button className="mr-1" variant="primary" type="button">
              <i className="fa fa-plus"></i>
              {" "}Add Flag
            </Button>
          </Col>
        </Row>
      </Card.Body>
      <Card.Footer>
        <Row>
          <Col className="d-flex finalColumn">
            <Button className="mr-1" variant="primary" onClick={!isSaveLoading ? onSaveClick : () => { }}>
              {saveButtonContent}
            </Button>
          </Col>
        </Row>
        {errorMessageContent}
        {succeedMessageContent}
      </Card.Footer>
    </Card>
  );
}
